function SectionHeading({ eyebrow, title, subtitle, align = "center" }) {
  return (
    <>
          
             <div className={`section-heading section-heading--${align}`}>
{eyebrow && <span className="eyebrow">{eyebrow}</span>}
            <h2 className="section-title">
              <span className="gradient-text">{title}</span>
            </h2>
            {subtitle && <p className="section-subtitle">{subtitle}</p>}
          </div>    
    </>
 
  );
}

export default SectionHeading;
